// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"859a71d3","293":"b6f6c958","453":"dfc0a397"}[chunkId] + ".chunk.js";
};